(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccl-home-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ccl-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-ccl-carousel-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-ccl-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-ccl-dot]'));
    if (!viewport || slides.length < 2) return;
    let index = 0;
    const move = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      viewport.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    carousel.querySelector('[data-ccl-prev]')?.addEventListener('click', () => move(index - 1));
    carousel.querySelector('[data-ccl-next]')?.addEventListener('click', () => move(index + 1));
    viewport.addEventListener('scrollend', () => {
      const width = viewport.clientWidth || 1;
      index = Math.round(viewport.scrollLeft / width);
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
